<template>
  <div class="layer">
    <div class="inner">
      <button type="button" class="btnClose" @click="onClose"><span class="blind">X</span></button>
      <h2 class="layerTitle toCapitalize">{{locale.tvcontrol_channel_list}}</h2>
      <div class="chSearch">
        <select name="" id="" class="input inlineInput chPreset" v-model="chPreset">
          <option value="">{{locale.preset}}</option>
          <option v-for="ch in preset"
            :key="ch.id"
            :value="ch.id">
            {{ch.name}}
          </option>
        </select>
        <input type="text" class="input inlineInput chFilter" :placeholder="locale.tv_search_placeholder_nameonly" v-model="chFilter" />
      </div>
      <div v-if="type === 'checkbox'" class="checkbox chAll">
        <input type="checkbox" id="chk_all_ch" v-model="chkAll" @change="activeAll">
        <label for="chk_all_ch" class="toCapitalize">{{locale.all}}</label>
      </div>
      <div v-if="list.length > 0" class="chList">
        <Item v-for="item in list"
          :locale="locale"
          :key="item.id"
          :item="item"
          :activeItem="activeItem"
          :selectedItem="selectedItem"
          :type="type"
          @onActiveItem="active"
          @onSelectedItem="selected" />
      </div>
      <div class="chApply">
        <button type="button" class="btn btnPrimary btnFull toUppercase" @click="onApply">
          {{type === 'checkbox' ? locale.apply : locale.select}}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import Item from '@/components/Tv/LibraryItem.vue'
import TVCHANNEL from '@/common/tvchannel'

export default {
  props: [
    'locale',
    'type'
  ],
  components: {
    Item
  },
  computed: {
    library () {
      return this.$store.getters['tv/chLibrary']
    },
    list () {
      let list = this.library.map(x => x)
      const preset = this.chPreset
      const word = this.chFilter.toLowerCase()
      if (preset !== '') {
        list = list.filter(x => x.preset.filter(x => x.id === preset).length > 0)
      }
      // 검색
      if (word.trim() !== '') {
        list = list.filter(x => x.name.toLowerCase().includes(word))
      }
      return list
    },
    lowercase () {
      return this.chFilter.toLowerCase()
    },
    lowercaselist () {
      return this.library.filter(x => x.name)
    },
    preset () {
      return TVCHANNEL.preset
    }
  },
  watch: {
    activeItem (ids) {
      this.chkAll = this.list.length === ids.length
    }
  },
  created () {
    const list = TVCHANNEL.list.map(x => x)
    this.$store.commit('tv/setChLibrary', list)
  },
  data () {
    return {
      chkAll: false,
      activeItem: [],
      selectedItem: '',
      chFilter: '',
      chPreset: ''
    }
  },
  methods: {
    activeAll () {
      this.activeItem = this.chkAll ? this.list.map(x => x.id) : []
    },
    active (ids) {
      this.activeItem = ids
    },
    selected (id) {
      this.selectedItem = id
    },
    onClose () {
      this.$emit('close')
    },
    onApply () {
      const isAdd = this.type === 'checkbox'
      if (isAdd) {
        if (window.confirm(this.locale.confirm_channel_add)) {
          const data = {
            ids: this.activeItem,
            preset: this.chPreset === '' ? null : this.chPreset
          }
          this.$store.commit('onLoading', true)
          this.$store.dispatch('tv/applyChannel', data).then(() => {
            this.$store.dispatch('tv/setChannel').then(() => {
              this.$store.dispatch('tv/getChData')
              this.$emit('close')
              alert(this.locale.complete_channel_add)
              this.$store.commit('onLoading', false)
            })
          })
        }
      } else {
        if (window.confirm(this.locale.confirm_channel_load)) {
          const id = this.selectedItem
          this.$store.dispatch('tv/setLoadChannel', id).then(() => {
            this.$emit('close')
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.layer .inner {
  max-width: 1200px;
}
.chSearch {
  margin-bottom: 30px;
  .chPreset {
    margin-right: 5px;
  }
  .chFilter {
    width: 240px;
  }
}
.chAll {
  display: block;
  margin-bottom: 5px;
  padding-left: 5px;
  flex: none;
  text-align: left;
}
.chList {
  max-height: 100%;
  overflow: auto;
  margin-left: 0;
}
.chApply {
  width: 180px;
  margin: 30px auto;
}
</style>
